module.exports = __webpack_public_path__ + "img/MYZ04.c953e41a.png";